module.exports = __webpack_public_path__ + "a166744b3d247ffa9d927353878a813f.ttf";